module.exports = __webpack_public_path__ + "static/baileymwjwinterpatrickincaddy-afe1a491557896d8161f0d6514ebc3a2.jpg";